export default __webpack_public_path__ + "navigation-examples-custom-server-1200-d1ce65075df6a9ea00614068220a1ff7.png";